import {
  FETCH_CANCEL_REASONS,
  FETCH_CANCEL_REASONS_SUCCESS,
  FETCH_CANCEL_REASONS_FAILED,
  EDIT_CANCELLATION_REASON
} from "../store/types";
import store from '../store/store';
import { getRecord, saveRecord, subscribeToRecord } from '../data/appRecords';

export const fetchCancelReasons = () => (dispatch) => {
  dispatch({
    type: FETCH_CANCEL_REASONS,
    payload: null,
  });
  const publish = (data) => {
    if (Array.isArray(data) && data.length) {
      dispatch({
        type: FETCH_CANCEL_REASONS_SUCCESS,
        payload: { simple: data.map((reason) => reason.label), complex: data },
      });
    } else {
      dispatch({
        type: FETCH_CANCEL_REASONS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_cancel_reason,
      });
    }
  };

  let unsubscribe = () => {};
  try {
    unsubscribe = subscribeToRecord('cancel_reason', 'main', publish);
  } catch (error) {
    dispatch({ type: FETCH_CANCEL_REASONS_FAILED, payload: error.message });
    return unsubscribe;
  }

  getRecord('cancel_reason', 'main').then(publish).catch((error) => {
    dispatch({ type: FETCH_CANCEL_REASONS_FAILED, payload: error.message });
  });
  return unsubscribe;
};

export const editCancellationReason = (reasons, method) => async (dispatch) => {
  dispatch({
    type: EDIT_CANCELLATION_REASON,
    payload: method
  });
  try {
    await saveRecord('cancel_reason', 'main', reasons);
  } catch (error) {
    dispatch({
      type: FETCH_CANCEL_REASONS_FAILED,
      payload: error.message,
    });
  }
}

